import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "d-flex align-items-center" }
const _hoisted_3 = { class: "text-muted align-middle mb-0" }
const _hoisted_4 = {
  key: 0,
  class: "mt-3 text-center"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_sub_section = _resolveComponent("sub-section")!
  const _component_state_pension_editor = _resolveComponent("state-pension-editor")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_sub_section, {
      title: "Your State Pension",
      helpTitle: "Your State Pension",
      helpText: _ctx.htmlArray('haves.state-pension.help')
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.statePensionText), 1)
          ]),
          (_ctx.isOverSPA)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-outline-secondary btn-sm",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onEditClicked($event)))
                }, _cache[1] || (_cache[1] = [
                  _createElementVNode("span", { class: "d-none d-sm-inline-block" }, "Edit state pension", -1)
                ]))
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 8, ["helpText"]),
    _createVNode(_component_modal, {
      title: "State Pension",
      ref: "statePensionModal",
      idKey: "statePensionModal",
      "close-button-aria-label": "Close State Pension popup editor"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_state_pension_editor, {
          ref: "statePensionEditor",
          onEditFinished: _ctx.onEditFinished
        }, null, 8, ["onEditFinished"])
      ]),
      _: 1
    }, 512)
  ], 64))
}